module.exports = __webpack_public_path__ + "static/media/gift2.5ddf59dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/gift2.jpg
// module id = 488
// module chunks = 0